module.exports = __webpack_public_path__ + "img/DNARepair-BRCA_10X_IDC.47b726b9.png";